import { IPage } from '../entities/page';
import { IShardClusterCreateRequest, IShardClusterRequestParams, IShardClusterUpdateRequest, IShardClusterDetailsItem, IShardClusterListItem, IDefaultShardCluster } from "../entities/shard-cluster";
import { DataService } from "./data-service";
import { API_ROUTES } from "../../constants/routes";

class ShardClusterService extends DataService {
    constructor() {
        super(API_ROUTES.shardCluster);
    }

    get(id: string): Promise<IShardClusterDetailsItem> {
        return this.api.get<IShardClusterDetailsItem>(id);
    }

    getPage(requestParams: IShardClusterRequestParams): Promise<IPage<IShardClusterListItem>> {
        return this.api.get<IPage<IShardClusterListItem>>(null, requestParams);
    }

    getDefault(): Promise<IDefaultShardCluster>{
        return this.api.get<IDefaultShardCluster>('default');
    }

    addShardCluster(addRequest: IShardClusterCreateRequest): Promise<IShardClusterListItem> {
        return this.api.post<IShardClusterListItem>(null, addRequest);
    }

    update(updateRequest: IShardClusterUpdateRequest): Promise<IShardClusterListItem> {
        return this.api.put<IShardClusterListItem>(updateRequest.id, updateRequest);
    }

    delete(id: string): Promise<void> {
        return this.api.delete(id);
    }
}

export const shardClusterService = new ShardClusterService();
